import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail, resolveImageUrl } from "../../lib/api";
import GeschenkBildUpload from "../../components/GeschenkBildUpload";
import { Gift } from "lucide-react";

export default function GeschenkeAdmin() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(blank());
  const load = () => api.get("/geschenke").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editing) await api.put(`/admin/geschenke/${editing.id}`, form);
      else await api.post("/admin/geschenke", form);
      setEditing(null); setForm(blank()); load();
    } catch (e) { alert(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  const remove = async (id) => {
    if (!window.confirm("Wirklich löschen?")) return;
    await api.delete(`/admin/geschenke/${id}`);
    load();
  };

  const edit = (g) => {
    setEditing(g);
    setForm({ name: g.name, beschreibung: g.beschreibung, bild_url: g.bild_url || "", coin_preis: g.coin_preis, mindest_stufe: g.mindest_stufe, vorraetig: g.vorraetig });
  };

  return (
    <div className="space-y-5" data-testid="geschenke-admin-page">
      <h1 className="text-3xl font-heading font-bold text-falke-blue">Geschenke-Katalog</h1>
      <div className="falke-card p-6 space-y-3">
        <h3 className="font-heading text-lg text-falke-blue">{editing ? `Bearbeite: ${editing.name}` : "Neues Geschenk"}</h3>
        <div className="grid sm:grid-cols-2 gap-3">
          <input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="px-3 py-2 rounded-xl border border-falke-blue/15" data-testid="g-name" />
          <input type="number" placeholder="Coin-Preis" value={form.coin_preis} onChange={(e) => setForm({ ...form, coin_preis: Number(e.target.value) })} className="px-3 py-2 rounded-xl border border-falke-blue/15" data-testid="g-preis" />
          <select value={form.mindest_stufe} onChange={(e) => setForm({ ...form, mindest_stufe: e.target.value })} className="px-3 py-2 rounded-xl border border-falke-blue/15" data-testid="g-stufe">
            <option>Bronze</option><option>Silber</option><option>Gold</option><option>Platin</option>
          </select>
          <label className="flex items-center gap-2 self-center"><input type="checkbox" checked={form.vorraetig} onChange={(e) => setForm({ ...form, vorraetig: e.target.checked })} className="w-4 h-4 accent-falke-orange" /> Vorrätig</label>
          <textarea placeholder="Beschreibung" value={form.beschreibung} onChange={(e) => setForm({ ...form, beschreibung: e.target.value })} className="sm:col-span-2 px-3 py-2 rounded-xl border border-falke-blue/15" data-testid="g-desc" />
          <div className="sm:col-span-2">
            <GeschenkBildUpload value={form.bild_url} onChange={(path) => setForm({ ...form, bild_url: path })} />
          </div>
        </div>
        <div className="flex gap-2">
          <button onClick={save} className="btn-primary" data-testid="g-save">{editing ? "Aktualisieren" : "Anlegen"}</button>
          {editing && <button onClick={() => { setEditing(null); setForm(blank()); }} className="btn-outline">Abbrechen</button>}
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((g) => (
          <div key={g.id} className="falke-card overflow-hidden" data-testid={`g-card-${g.id}`}>
            {g.bild_url ? (
              <img src={resolveImageUrl(g.bild_url)} alt="" className="w-full h-40 object-cover" />
            ) : (
              <div className="w-full h-40 bg-falke-warmwhite flex items-center justify-center"><Gift size={40} className="text-falke-blue/30" /></div>
            )}
            <div className="p-4">
              <div className="font-semibold text-falke-blue">{g.name}</div>
              <div className="text-xs text-falke-anthracite/70 line-clamp-2">{g.beschreibung}</div>
              <div className="flex items-center justify-between mt-2">
                <span className="text-falke-orange font-bold tabular">{g.coin_preis} FC</span>
                <span className="text-xs text-falke-blue/70">{g.mindest_stufe}</span>
              </div>
              <div className="flex gap-2 mt-3">
                <button onClick={() => edit(g)} className="btn-outline !py-1.5 text-xs flex-1" data-testid={`g-edit-${g.id}`}>Bearbeiten</button>
                <button onClick={() => remove(g.id)} className="text-rose-600 text-xs hover:underline" data-testid={`g-del-${g.id}`}>Löschen</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function blank() {
  return { name: "", beschreibung: "", bild_url: "", coin_preis: 200, mindest_stufe: "Bronze", vorraetig: true };
}
